import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { PlaylistShareButtonMeta, SocialNetwork } from '@adobe/edex/ui/types';
import { getAssetURL } from '@adobe/edex/ui/utils';
import './socialMediaShare.scss';
import '@spectrum-web-components/icons-workflow/icons/sp-icon-link';
import { infoToast } from '@adobe/edex/ui/utils/notification';

@customElement(EdexTagName.socialMediaShare)
export class SocialMediaShare extends BaseElement {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      title: { type: String },
      selected: { type: String },
      link: { type: String },
      linkToolTip: { type: Boolean },
      showToolTip: { type: Boolean },
    };
  }

  link = '';
  linkToolTip = false;
  showToolTip = false;

  get shareButtons(): PlaylistShareButtonMeta[] {
    const link = this.link.replace('local.', '');
    return [
      {
        name: SocialNetwork.Facebook,
        shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${link}`,
        className: 'fs-facebook-share-btn',
        toolTipExists: false,
      },
      {
        name: SocialNetwork.Twitter,
        shareUrl: `https://twitter.com/intent/tweet?url=${link}`,
        className: 'fs-twitter-share-btn',
        toolTipExists: false,
      },
      {
        name: 'link',
        shareUrl: link,
        className: 'fs-link-share-btn',
        toolTipExists: true,
      },
    ];
  }

  handleShare(event, { shareUrl, name }: Partial<PlaylistShareButtonMeta>) {
    const { linkToolTip } = this;
    event.preventDefault();
    if (name === 'link') {
      navigator.clipboard.writeText(shareUrl);
      if (!linkToolTip) {
        infoToast({ message: 'Link copied' });
      } else {
        this.showToolTip = true;
      }
    } else {
      window.open(
        shareUrl,
        'targetWindow',
        'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=350'
      );
    }
    this.emitEvent('share', { shareUrl, name }, { bubbles: true, composed: true });
  }

  render() {
    const { showToolTip } = this;
    return html`
      <div class="social-media-share-container">
        ${this.shareButtons.map(
          ({ name, shareUrl, className, toolTipExists }) => html`
            <a
              class="share-button ${className}"
              href="${shareUrl}"
              target="_blank"
              @click="${(e) => this.handleShare(e, { name, shareUrl })}"
            >
              <div class="share-icon-container ${name}">
                <img src="${getAssetURL(`${name.toLowerCase()}.svg`)}" alt="${name}" />
                <p>${name}</p>
              </div>
            </a>
            ${showToolTip && toolTipExists
              ? html`
                  <sp-tooltip open variant="positive" placement="right">Link Copied</sp-tooltip>
                `
              : null}
          `
        )}
      </div>
    `;
  }
}
